export default "__VITE_ASSET__yXCZnPFz__"